<div class="condensed-short-header-wrapper">
  <!-- TITLE AND SUBTITLE -->
  <div class="title-subtitle">
    <ng-container *ngIf="(titleGroup?.fields)[0] != null">
      <ng-container
        *ngIf="templateProjectionMap != null && titleGroup.fields[0].options?.hasAnchor; else subtitleName"
        [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
        [ngTemplateOutletContext]="{
          classes: 'record-link',
          urlParams:
            reportRecordData
            | reportFieldRouteFn: { templateId: currentView.templateId, field: (titleGroup?.fields)[0] },
          content: subtitleName,
        }"
      >
      </ng-container>
      <ng-template #subtitleName>
        <div class="title-subtitle__name">
          {{
            reportRecordData
              | reportFieldFormatter
                : {
                    templateId: currentView.templateId,
                    field: (titleGroup?.fields)[0],
                    joinString: true,
                    onlyUrl: false,
                  }
              | async
          }}
        </div>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="(titleGroup?.fields)[1] != null">
      <ng-container
        *ngIf="templateProjectionMap != null && titleGroup.fields[1].options?.hasAnchor; else subtitleValue"
        [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
        [ngTemplateOutletContext]="{
          classes: 'record-link',
          urlParams:
            reportRecordData
            | reportFieldRouteFn: { templateId: currentView.templateId, field: (titleGroup?.fields)[1] },
          content: subtitleValue,
        }"
      >
      </ng-container>
      <ng-template #subtitleValue>
        <div
          class="title-subtitle__address"
          *ngIf="
            reportRecordData | isFieldVisible: { templateId: currentView.templateId, field: titleGroup?.fields[1] }
          "
        >
          {{
            reportRecordData
              | reportFieldFormatter
                : {
                    templateId: currentView.templateId,
                    field: (titleGroup?.fields)[1],
                    joinString: true,
                    onlyUrl: false,
                  }
              | async
          }}
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="properties-component">
    <ul *ngIf="attributesGroup && attributesGroup?.fields.length">
      <li *ngFor="let field of attributesGroup.fields" [class]="field.class ? field.class : ''">
        <ng-container *ngIf="!!field.label; else noLabel">
          <label [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">{{
            field.label
          }}</label>
          <span [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">
            {{
              reportRecordData
                | reportFieldFormatter
                  : {
                      templateId: currentView.templateId,
                      field: field,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            }}
          </span>
        </ng-container>

        <ng-template #noLabel>
          <label [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">{{
            reportRecordData
              | reportFieldFormatter
                : {
                    templateId: currentView.templateId,
                    field: field,
                    joinString: true,
                    onlyUrl: false,
                  }
              | async
          }}</label>
        </ng-template>
      </li>
    </ul>
  </div>
</div>
